<template>
    <div class="list-product-card">
        <!-- Shop Wrapper Start -->
        <div class="row list-product-card-inner">
            <div class="col-12 col-custom mb-30">
                <div class="blog-list">
                    <div class="single-blog">
                        <div class="blog-image">
                            <a class="d-block" :href="blogUrl">
                                <img :src="baseImage" :class="{ 'image-placeholder': ! hasBaseImage }" alt="blog image" class="product-image-1">
                            </a>
                        </div>
                        <div class="blog-content">
                            <div class="blog-text">
                                <a :href="blogUrl" class="blog-name">
                                    <h4 class="title-blog">{{ blog.name }}</h4>
                                    <span v-html="formatDate"></span>
                                </a>

                                <div class="clearfix"></div>

                                <!-- <BlogRating :ratingPercent="blog.rating_percent" :reviewCount="blog.reviews.length"/> -->

                                <div class="blog-post-info">
                                </div>
                                 <p v-html="blog.short_description"></p>

                                   <a
                                        class="btn-default show-more"
                                        :href="blogUrl"
                                        >
                                    {{ $trans('nya::blogs.read_more') }}
                                    </a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
  
        </div>
    </div>
</template>

<script>
    import BlogRating from '../../BlogRating.vue';
    import BlogCardMixin from '../../../mixins/BlogCardMixin';

    export default {
        components: { BlogRating },

        mixins: [
            BlogCardMixin,
        ],

        props: ['blog'],
    };
</script>
